import { QUIZ_TEXT, useQuizLang } from '../lib/quizLang';

/**
 * Переключатель языка сайта (RU/EN). Живёт в шапке на всех страницах;
 * состояние глобальное — localStorage + синхронизация между вкладками.
 */
export function LangToggle() {
  const [lang, setLang] = useQuizLang();
  return (
    <div className="theme-toggle" role="group" aria-label={QUIZ_TEXT[lang].langLabel}>
      <button aria-pressed={lang === 'ru'} onClick={() => setLang('ru')}>
        RU
      </button>
      <button aria-pressed={lang === 'en'} onClick={() => setLang('en')}>
        EN
      </button>
    </div>
  );
}
